import * as React from "react";

export const SvgSeen = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M1.544 11.25a9.444 9.444 0 0 0 16.912 0 2.863 2.863 0 0 0 0-2.531 9.444 9.444 0 0 0-16.912.031 2.875 2.875 0 0 0 0 2.5Zm1.119-1.975a8.194 8.194 0 0 1 14.674 0 1.6 1.6 0 0 1 0 1.412 8.194 8.194 0 0 1-14.674 0 1.6 1.6 0 0 1 0-1.393v-.019Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.2}
		/>
		<path
			d="M10 13.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Zm0-6.25a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.2}
		/>
	</svg>
);
